<template lang='pug'>
  v-tooltip(left)
    template(v-slot:activator='{on}')
      .test-square.text-center(
        @click='to(`/results/${testSuite.runGuid}?index=${index}`)'
        @click.right.stop.prevent='to(`/test/${test.guid}`)'
        v-on='on'
        :style='style')
        bionic-metrics-running-indicator(v-if='testStatus && testStatus.isRunning' :dark='!$vuetify.theme.dark')
        v-icon(size='2vmin' v-if='test.disabled' color='white').disabled-test not_interested
    strong {{test.name}}
    div(v-if='testStatus')
      div(v-if='testStatus.statusUpdatedAt')
        | Updated
        | {{testStatus.statusUpdatedAt | timeago}}
      div(v-if="testStatus.status === 'PASSING'") Passing
      div(v-if="testStatus.status === 'FAILING'") Failing
      div(v-if='testStatus.isRunning') Running
    div(v-if='!testStatus') No Data Yet
    div(v-if='test.disabled') Disabled
</template>

<script>
import {get} from 'lodash';
import UtilMixin from '../mixins/util.mixin';
import BionicMetricsRunningIndicator from './RunningIndicator';

export default {
  name: 'BionicMetricsTestTile',
  components: {BionicMetricsRunningIndicator},
  mixins: [UtilMixin],
  props: {
    testSuite: {
      type: Object
    },
    test: {
      type: Object
    },
    testStatus: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    dark() {
      return this.$vuetify.theme.dark;
    },
    greenColor() {
      const theme = this.dark ? 'dark' : 'light';
      return get(this.$vuetify, `theme.themes.${theme}.success.base`, '#00C853');
    },
    size() {
      const total = this.testSuite.tests.length;
      return this.dark ?  `${Math.max(Math.ceil(9 - Math.log2(total)), 4)}vmin` : `${Math.max(Math.ceil(11 - Math.log2(total)), 4)}vmin`;
    },
    color() {
      if (!this.testStatus || this.test.disabled) return '#CFD8DC';
      if (this.testStatus.status === 'PASSING') return this.greenColor;
      if (this.testStatus.status === 'FAILING') return '#D84315';
      if (this.testStatus.status === 'WARNING') return '#FF9800';
      return '#CFD8DC';
    },
    style() {
      return {
        width: this.size,
        height: this.size,
        backgroundColor: this.color
      };
    }
  }
};
</script>

<style scoped>
.test-square {
  position: relative;
  width: 10vmin; /* Starting defautls see getSize for control */
  height: 10vmin; /* Starting defautls see getSize for control */
  min-width: 40px; /* Starting defautls see getSize for control */
  min-height: 40px; /* Starting defautls see getSize for control */
  margin: 0.25vmin;
  border-radius: 4px;
  background-color: #00C853;
  color: white;
  cursor: pointer;
  transition: transform .1s; /* Animation */

  display: flex;
  justify-content: center;
  align-items: center;
}

.test-square:hover {
  transform: scale(1.1);
}

.disabled-test {
  font-size: 16px;
  bottom: 3px;
  right: 3px;
  position: absolute;
}

</style>
